import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#327D23',
        secondary: '#883E44',
        accent: '#CCDE9D',
        error: '#FF2828',
        info: '#746F8F',
        success: '#25A979',
        warning: '#FC8B06',
      },
    },
  },
});
